import { useContext } from "react"
import { MenuContext } from "context/index"

const useMenu = () => {
	return useContext(MenuContext)
}

export default useMenu